export default class MoshikScrollAnimation extends HTMLElement {
  private fixed: boolean;
  private group: string;

  connectedCallback() {
    this.fixed = this.hasAttribute('fixed');
    this.group = this.getAttribute('group');

    window.addEventListener('scroll', () => this.onScroll());
    window.addEventListener('load', () => this.onScroll());
    window.addEventListener('resize', () => this.onScroll());
  }

  onScroll() {
    if (this.isScrollable()) {

      const percentage = this.fixed ?
          this.getFixedPercentage() :
          this.getStaticPercentage();

      this.setConnectedValue(Math.round(percentage * 100));
    }
    else {
      this.setConnectedValue(100);
    }
  }

  getFixedPercentage() {
    return window.scrollY / (document.body.clientHeight - window.innerHeight);
  }

  getStaticPercentage() {
    const topmostItem = this.getFirstItemInGroup().offsetTop;

    const rect = this.getBoundingClientRect();
    const top = rect.top;
    const height = rect.height;
    const winHeight = window.innerHeight;

    return 1 - (top - topmostItem + height) / winHeight;

  }

  getFirstItemInGroup() {
    const selector = `moshik-scroll-animation[group="${this.group}"]`;
    return <HTMLElement>document.querySelectorAll(selector)[0];
  }

  setConnectedValue(number) {
    this.style['fontVariationSettings'] = `"cnnt" ${number}`;
  }

  isScrollable() {
    return document.body.clientHeight > window.innerHeight;
  }


}